<template lang="pug">
.order-content
  .header-margin-bottom
  .member-center-header
    .arrow_icon(@click="$router.go(-1)")
      img(src="@/assets/images/arrow_left.svg", alt="alt")
    h1 我的預約
  .station-vk
    .back-pic
      span(v-for="_station in $root.stations", :key="_station.id")
        img.station-back(
          v-if="$root.currentRegister.stationId === _station.id && _station.id === $root.currentRegister.stationId" 
          :src="_station.banner", alt="alt"
        )
    .flag-box(v-for="_station in $root.stations", v-if="$root.currentRegister.stationId === _station.id")
      span(v-for="storeType in $root.types")
        img.station-flag(v-if="storeType.id === _station.typeId" :src="storeType.img", alt="alt")
  h2 零碳智慧租賃 合作店家
  h3 {{ getStationName($root.currentRegister.stationId) }}
  //- h5  
    span(v-if="station.id == $root.currentRegister.stationId", v-for="(station, index) in $root.stations") {{ station.address }} 
  .info-thanks 感謝您預約了 點點通好好玩<br/>以下是您的預約資訊
  .info-check
    .check_img
      img(src="@/assets/images/nike.svg", alt="alt")
    span 提醒確認
  .info-content.mb15
    .date-info {{ $root.common.getNowTime('date',$root.currentRegister.startTime + ':00') }}
      span {{ $root.common.getNowTime('time',$root.currentRegister.startTime + ':00') }}
    .info-item
      .info-title 真實姓名
      .info-contetn {{ $root.member.name }}
    .info-item
      .info-title 項目
      .info-contetn
        .text(v-for="( carType , index ) in $root.carTypes") 
          span(v-for="car in $root.currentRegister.carTypes" v-if="carType.id === car.typeId") {{ carType.content }}
    .info-item
      .info-title 數量
      .info-contetn {{ getOrderCarCount($root.currentRegister) }} 台
    .info-item(v-if="$root.currentRegister.timeType === 'day'")
      .info-title 天數
      .info-contetn {{ $root.currentRegister.days }} 天
    .info-item(v-if="$root.currentRegister.timeType === 'hour'")
      .info-title 時數
      .info-contetn {{ $root.currentRegister.hours }} 小時
    //- .info-item
      .info-title 費用
      .info-contetn
    .info-item
      .info-title 站址
      .info-contetn
        span {{ getStationAddress($root.currentRegister.stationId) }}
</template>

<script>
export default {
  name: "order-content",
  components: {},
  data () {
    return {
    };
  },
  mounted () { },
  methods: {
    getStationName (_stationId) {
      let searchStationName = ""
      this.$root.stations.forEach(function (station) {
        if (station.id == _stationId) {
          searchStationName = station.name
        }
      })

      return searchStationName
    },
    getStationAddress (_stationId) {
      let searchStationAddress = ""
      this.$root.stations.forEach(function (station) {
        if (station.id == _stationId) {
          searchStationAddress = station.address
        }
      })

      return searchStationAddress
    },
    getOrderCarCount (_order) {
      console.log('OrderCarCount:', _order.carTypes)

      let counts = 0
      _order.carTypes.forEach(function (_car) {
        counts += parseInt(_car.amount)
      })

      return counts
    }
  }
};
</script>
<style lang="sass" scoped>
body
  position: relative
.order-content
  background-color: #000
  padding: 0 3.75vmin
  height: 100%
  overflow: auto
  .arrow_icon
    position: absolute
    top: 5vmin
    left: 6.1vmin
    z-index: 10
    position: fixed
  h1
    font-size: 4.75vmin;
    font-weight: 700;
    color: #fff;
    padding: 6vmin;
    position: fixed;
    z-index: 9;
    width: 100%;
    text-align: center;
    left: 0px;
    top: 0px;
  .station-vk
    position: relative
    .back-pic
      margin: 0 -3.75vmin
      
    .flag-box
      width: 23%
      aspect-ratio: 1/1;
      background-color: #202020
      border-radius: 50%
      display: flex
      align-items: center
      position: absolute
      left: 0
      right: 0
      bottom: -25.773195%
      margin: auto
      border: 1px solid rgba(0, 0, 0, 0.3)
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25)
      z-index: 1
      .station-flag
        width: 80%
        vertical-align: top
    img
      width: 100%
      vertical-align: middle
  h2
    text-align: center
    font-size: 9vmin
    font-weight: 700
    color: #FFF
    margin-top: 3.75vmin
    margin-top: 15.5vmin
    line-height: 10vmin
  h3,h5
    color: #FFF
    text-align: center
    font-size: 7vmin
    font-weight: 700
  h5
    font-size: 4vmin
  .info-thanks
    color: #898A8D
    text-align: center
    font-size: 4.5vmin
    font-weight: 400
    margin: 7vmin 0 5vmin 0
  .info-check
    color: #22F48F
    text-align: center
    font-size: 4.5vmin
    font-weight: 300
    margin-bottom: 6vmin
    display: flex
    justify-content: center
    align-items: center
    gap: 5px
    .check_img
      width: 5vmin
      height: 5vmin
      background: #22F48F
      border-radius: 50%
      display: flex
      align-items: center
      justify-content: center

  .info-content
    background-color: #1E1E1E
    border-radius: 10px
    padding: 5vmin 7.5vmin 4vmin 7vmin
    margin: 0 auto
    width: 95%
    margin-bottom: 15%
    .date-info
      font-size: 4.5vmin
      font-weight: 700
      color: #FFF
      margin-bottom: 4vmin
      span
        float: right
        color: #22F48F
    .info-item
      display: flex
      color: #FFF
      font-size: 3.75vmin
      font-weight: 400
      margin-bottom: 1.5vmin
      .info-contetn
        margin-left: 6.5vmin
.header-margin-bottom
  margin-bottom: 75px
.member-center-header
  position: fixed
  left: 0px
  top: 0px
  width: 100%
  background: #000
  z-index: 10
  height: 75px
</style>
